import React, { useEffect } from 'react';
import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { IRootDispatch, IRootState } from 'stores/rematch/root-store';
import './bookings-table.css';

import { BookingsTable } from './bookings-table';
import CommonUtils from 'utilities/common-utils';
import { useHistory } from 'react-router-dom';

interface BookingTableViewProps {
  setShowBookingFilters?: (value: boolean) => void;
  showBookingFilters?: boolean;
}

export const BookingsTableView = ({ setShowBookingFilters, showBookingFilters }: BookingTableViewProps) => {
  const selectedFilterKey = useSelector((state: IRootState) => state.bookingsStore.selectedFilterKey);
  const bookingsFilter = useSelector((state: IRootState) => state.bookingsStore.bookingsFilter);
  const defaultBookingViews = useSelector((state: IRootState) => state.bookingsStore.defaultBookingViews);
  const displayedBookingListingTabs = useSelector(
    (state: IRootState) => state.bookingsStore.displayedBookingListingTabs,
  );
  const dispatch = useDispatch<IRootDispatch>();
  const setSelectedFilterKey = dispatch.bookingsStore.setSelectedFilterKey;
  const setBookingsFilter = dispatch.bookingsStore.setBookingsFilter;
  const setBookingListingActiveTab = dispatch.bookingsStore.setBookingListingActiveTab;
  const history = useHistory();

  // If the user re-click on the selected filter, reset the filters as default
  const setFilter = async (filterKey: string) => {
    if (selectedFilterKey === filterKey) {
      const view = defaultBookingViews.find((tab) => tab.customViewId === filterKey);
      if (view) {
        setBookingsFilter(view.filterValue);
      }
    }
    setSelectedFilterKey(filterKey);
  };

  const hideFilterTabToggle = () => {
    setShowBookingFilters?.(!showBookingFilters);
  };

  useEffect(() => {
    // resets filters if none is selected
    if (_.isEmpty(selectedFilterKey)) {
      const defaultFilterKey = 'ALL';

      (async () => {
        await setBookingListingActiveTab(defaultBookingViews[0]);
        await setSelectedFilterKey(defaultFilterKey);
        if (defaultBookingViews[0]) {
          await setBookingsFilter(defaultBookingViews[0].filterValue);
        }
      })();
    }
  }, [selectedFilterKey, setSelectedFilterKey, setBookingsFilter, setBookingListingActiveTab, defaultBookingViews]);
  let selectedFilterKey_ = selectedFilterKey ?? 'ALL';

  if (_.isEmpty(selectedFilterKey_)) {
    selectedFilterKey_ = 'ALL';
  }

  const currentFilterConfig = [...defaultBookingViews, ...displayedBookingListingTabs].find(
    (view) => view.customViewId === selectedFilterKey_,
  );

  const searchFilter = CommonUtils.findFilter('search', bookingsFilter);
  if (searchFilter && currentFilterConfig) {
    currentFilterConfig.filterValue.search = searchFilter; // this is wrong or we are missing type info
  }

  return (
    <BookingsTable
      currentFilterConfig={currentFilterConfig}
      hideFilterTabToggle={hideFilterTabToggle}
      history={history}
      setFilter={setFilter}
      showFilterSection={showBookingFilters}
    />
  );
};
